import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { BiLoggerService } from '@core/services/logger/bi-logger.service';
import { TlkCardComponent } from '@itero/ui-toolkit-angular/card';
import { TlkSlideToggleComponent } from '@itero/ui-toolkit-angular/slide-toggle';
import { DentureDetailsComponent } from '@modules/denture-details/containers/denture-details/denture-details.component';
import { MouldsDropdownComponent } from '@modules/denture-details/components/moulds-dropdown/moulds-dropdown.component';
import { DentureDetailsFacade } from '@modules/denture-details/denture-details.facade';
import { RxIntuitiveDentureVisibilityService } from '@modules/rx-intuitive-denture-procedure/rx-intuitive-denture-visibility.service';
import { TranslateModule } from '@ngx-translate/core';
import { RxProcedureTypeControlComponent } from '@shared/components/rx-procedure-type-control/rx-procedure-type-control.component';
import { SharedModule } from '@shared/shared.module';
import { TextInputComponent } from '@shared/components/text-input/text-input.component';

@Component({
	selector: 'rx-intuitive-denture-procedure',
	templateUrl: './rx-intuitive-denture-procedure.component.html',
	styleUrls: ['./rx-intuitive-denture-procedure.component.scss'],
	providers: [DentureDetailsFacade],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		TranslateModule,
		SharedModule,
		TlkCardComponent,
		TlkSlideToggleComponent,
		RxProcedureTypeControlComponent,
		MouldsDropdownComponent,
		TextInputComponent
	]
})
export class RxIntuitiveDentureProcedureComponent extends DentureDetailsComponent implements OnInit {
	constructor(
		formBuilder: FormBuilder,
		dentureDetailsFacade: DentureDetailsFacade,
		biLogger: BiLoggerService,
		dentureVisibilityService: RxIntuitiveDentureVisibilityService,
		cdr: ChangeDetectorRef
	) {
		super(formBuilder, dentureDetailsFacade, biLogger, dentureVisibilityService, cdr);
	}

	switchOffControl(event: boolean, control: FormControl): void {
		if (!event && !this.isReadOnly) {
			control.patchValue(false);
		}
	}
}
